import PendoMultiselectCore from './pendo-multiselect-core.js';
import PendoMultiselectOptions from './pendo-multiselect-options.vue.js';
import PendoMultiselectInput from './pendo-multiselect-input.vue.js';
import PendoMultiselectTrigger from './pendo-multiselect-trigger.vue.js';
import PendoMultiselectValue from './pendo-multiselect-value.vue.js';
import PendoMultiselectProps from './pendo-multiselect-props.js';
import PickerPopover from '../../utils/picker-popover.vue.js';

var script = {
  name: 'PendoMultiselect',
  components: {
    PendoMultiselectInput,
    PendoMultiselectCore,
    PendoMultiselectOptions,
    PendoMultiselectTrigger,
    PendoMultiselectValue,
    PickerPopover
  },
  mixins: [PendoMultiselectProps],
  inject: {
    $formItem: {
      default: ''
    }
  },
  inheritAttrs: false,
  computed: {
    ariaLabel() {
      if (this.$attrs && this.$attrs['aria-label']) {
        return this.$attrs['aria-label'];
      }
      return undefined;
    },
    ariaLabelledBy() {
      if (this.$formItem) {
        return this.$formItem.labelId;
      }
      return undefined;
    }
  },
  methods: {
    toggleMenu() {
      return this.$refs.core.toggleMenu();
    },
    pointerSet(index) {
      return this.$refs.core.pointerSet(index);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-multiselect.vue2.js.map
